import React from "react";
import "./StatsBanner.css";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const StatsBanner = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.35,
  });

  const stats = [
    { value: 25000, suffix: "+ MW", label: "Grid Compliance Studies" },
    { value: 52000, suffix: " MW", label: "Evacuation Studies" },
    { value: 60000, suffix: " MW", label: "Optimization Studies" },
    { value: 3800, suffix: " MW", label: "Protection Studies" },
    { value: 800, suffix: " MW", label: "Renewable Integration" },
    { value: 120, suffix: "+", label: "Planning & Feasibility Projects" },
  ];

  
    return (
    <motion.section
      className="stats-banner"
      ref={ref}
      initial={{ opacity: 0, x: -80 }}
      animate={inView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="stats-wrapper">
        {stats.map((item, index) => (
          <div className="stats-item" key={index}>
            <h2 className="stats-number">
              {inView && (
                <CountUp
                  end={item.value}
                  duration={2.5}
                  separator=","
                />
              )}
              <span>{item.suffix}</span>
            </h2>

            <p>{item.label}</p>
          </div>
        ))}
     </div>
    </motion.section>
  );
};

export default StatsBanner;